import Const = require("./utils/const");
import EventTypes = Const.EventTypes;

export class RestrictMultipleSubmit {

    //送信可否
    private static isSubmit: boolean = false;

    //クリックオブジェクトが多重送信防止処理対象外か否か
    private static isIgnoreObject: boolean = false;

    //渡されたクラス名をもとに多重送信防止イベントを設定
    static setRestrictMultipleSubmit(): void {

        this.setRestrictMultipleSubmitJQueryProcess();

        const formElements = Array.prototype.slice.call(document.getElementsByTagName("form")) as Array<HTMLFormElement>;

        formElements.forEach(elm => {
            if (!elm.classList.contains("ignore-multiple-submit")) {
                this.setIgnoreMultipleSubmitObject(elm);
                this.setRestrictMultipleSubmitEvent(elm);
            }
        });
    }

    //jQuery Validation用多重送信防止イベントの設定
    private static setRestrictMultipleSubmitJQueryProcess(): void {
        //jQuery Validationの読み込み確認
        if (typeof jQuery != "undefined" && typeof $.validator != "undefined") {
            $.validator.unobtrusive.options = {
                errorPlacement: function ($error) {
                    if ($error.text().length === 0) {
                        return true;
                    } else {
                        RestrictMultipleSubmit.isSubmit = false;
                        //送信ボタンを有効化(イベントハンドラのほうが先に呼ばれるため)
                        $(this).closest("form").find("[type='submit']").css("pointer-events", "auto");
                        return false;
                    }
                }
            }
        }
    }

    //渡されたHTMLFormElementに対し多重送信防止イベントを設定
    private static setRestrictMultipleSubmitEvent(form: HTMLFormElement): void {
        form.addEventListener(EventTypes.SUBMIT as any,
            () => {
                if (!this.isIgnoreObject && !this.isSubmit) {
                    const elements = form.elements;
                    for (let i = 0; i < elements.length; i++) {
                        const element = elements[i] as HTMLElement;

                        if (element.getAttribute("type") === "submit") {
                            //送信ボタンを無効化
                            var elm = (element as HTMLButtonElement);
                            elm.style.pointerEvents = "none";
                            elm.disabled = true;

                            // 戻し
                            var self = this;
                            if (elm.classList.contains("restrict-multiple-submit-do-once")) {
                                window.setTimeout(() => {
                                        self.isSubmit = false;
                                    },
                                    5000);
                            } else {
                                window.setTimeout(() => {
                                        elm.style.pointerEvents = "auto";
                                        elm.disabled = false;
                                        self.isSubmit = false;
                                    },
                                    10000);
                            }
                        }
                    }
                    this.isSubmit = true;
                }
                this.isIgnoreObject = false;
                return true;
            });
    }

    //多重送信防止対象外イベントの判定
    private static setIgnoreMultipleSubmitObject(form: HTMLFormElement): void {
        const elements = form.elements;
        for (let i = 0; i < elements.length; i++) {
            const formObject = elements[i];
            if (formObject.getAttribute("type") === "submit") {
                formObject.addEventListener(EventTypes.CLICK as any,
                    () => {
                        if (formObject.classList.contains("ignore-multiple-submit")) {
                            this.isIgnoreObject = true;
                        }
                    });
            }
        }
    }
}
